import axios from 'axios';
let authorizationHeader = null;
let portausContextnHeader = null;

export default {
  uploadFile(file, successFunction, errorFunction){
    var instance = axios.create();
    authorizationHeader = instance.defaults.headers.common['Authorization'];
    delete instance.defaults.headers.common['Authorization'];
    portausContextnHeader = instance.defaults.headers.common['X-Portaus-Context'];
    delete instance.defaults.headers.common['X-Portaus-Context'];
    let formData = new FormData();
    let format = file.type.match(/image*/i)!=null ? 'image' : 'video';
    formData.append('upload_preset',process.env.VUE_APP_CLOUDINARY_UPLOAD_PRESET);
    formData.append('file', file)
    return instance({
      method: 'post',
      url: process.env.VUE_APP_CLOUDINARY_URL+'/'+format+'/upload',
      data: formData,
      headers: {'Content-Type': 'multipart/form-data' }
    })
    .then(response=>{
      instance.defaults.headers.common['Authorization'] = authorizationHeader;
      instance.defaults.headers.common['X-Portaus-Context'] = portausContextnHeader;
      return response;
    })
    .then(response=>successFunction(response))
    .catch(err=>{
      console.log(err);
      instance.defaults.headers.common['Authorization'] = authorizationHeader;
      instance.defaults.headers.common['X-Portaus-Context'] = portausContextnHeader;
      return errorFunction(err)
    })
  },
  buildGalleryObjectModel(link, type_id, code, description){

  }
}
